import DatePickerContainer from "../../../../components/formsAndTable/forms/formWidgets/datePicker";

const DatePicker = () => {
  return <DatePickerContainer />;
};

export default DatePicker;
